import { render, staticRenderFns } from "./AnnotationRightClickPopup.vue?vue&type=template&id=198ed182&scoped=true"
import script from "./AnnotationRightClickPopup.vue?vue&type=script&lang=js"
export * from "./AnnotationRightClickPopup.vue?vue&type=script&lang=js"
import style0 from "./AnnotationRightClickPopup.vue?vue&type=style&index=0&id=198ed182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ed182",
  null
  
)

export default component.exports